<template>
	<div class="recommend">
	    <div><img src="/images/title.png"/></div>
	    <ul>
				<li v-for="(item,index) in relatedata">
					<router-link :to="{ name: 'detail', params: { id: item.id }, query:{ source: source }}" :title="item.title" target="_blank">{{item.title}}</router-link>
				</li>
	        <!-- <li><a href="##">科技赋能为美好生活“添彩”——各地探索智慧公园</a></li>
	        <li><a href="##">数字文旅在粤如何落地？十大数字化应用典型案例</a></li>
	        <li><a href="##">数字化转型案例说 | 中国信通院助力湖北交投集团</a></li>
	        <li><a href="##">宁波市：以“一网统管”引领数字化改革 全力打造</a></li> -->
	    </ul>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				
			}
		},
		props:[
			'relatedata',
			'source'
		],
	}
</script>

<style>
</style>
